/* eslint-disable camelcase */

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback } from 'react';
import metadata from './SurveyComponent.metadata.json5';
import styles from './SurveyComponent.module.scss';

function SurveyComponent(props) {
    const { associationName_TWIA, configs } = props;
    const isTWIA = associationName_TWIA === "twia";
    const twiaSurveyURL = configs.EdgePortal_URL_TWIA_Customer_Survey || 'https://www.research.net/r/TWIA'
    const tfpaSurveyURL = configs.EdgePortal_URL_TFPA_Customer_Survey || 'https://www.research.net/r/TFPA'

    const onTakeClaimSurvey = useCallback(() => {
        const url = isTWIA ? twiaSurveyURL : tfpaSurveyURL;

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank')
    }, [isTWIA, tfpaSurveyURL, twiaSurveyURL]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        takeClaimSurvey:{
            onClick: onTakeClaimSurvey
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        }

    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

SurveyComponent.propTypes = {
    data: PropTypes.shape({}),
};

export default SurveyComponent;